import React from 'react';
import { UserInfoProps } from '../../../types';

const UserInfo: React.FC<UserInfoProps> = ({ userInfo }) => {
  return (
    <div className="user-info">
      <h2>Witaj, {userInfo.name || userInfo.preferred_username}! 👋</h2>
      <p><strong>Username:</strong> {userInfo.preferred_username}</p>
      <p><strong>Email:</strong> {userInfo.email}</p>
      {userInfo.name && <p><strong>Full Name:</strong> {userInfo.name}</p>}
    </div>
  );
};

export default UserInfo;
